<div class="layout-column full-height">


  <cdk-virtual-scroll-viewport autosize class="flex layout-column" *ngIf="tasks?.length">
    <app-task-item *cdkVirtualFor="let task of tasks; let index = index"
                   appBringozIdGenerator="itineraryTaskItem"
                   class="flex"
                   [task]="task"
                   [disableActions]="agentConfigurationProfile?.itineraryPreferences?.lockTaskSequenceEdit && !isDisableEntityStateLock"
                   [analysis]="task.analysis"
                   [taskIndex]="isUseSequence ? task.analysis?.daySequence : getTaskNumber(task)"
                   [isSelected]="selectedTaskItemIds[task.id]"
                   [isHighlighted]="highlightedServiceId == task?.serviceId"
                   [itinerariesTaskSettings]="itinerariesTaskSettings"
                   [showBundleTaskList]="toggleBundledTaskIdsMap[task.id]"
                   [showRelatedTaskList]="toggleRelatedTaskIdsMap[task.id]"
                   (clickRelatedTaskListToggleEvent)="onClickRelatedTaskListToggle($event)"
                   (clickBundleTaskListToggleEvent)="onClickBundledTaskListToggle($event)"
                   (click)="onHighlightedChanged.emit({serviceId: task.serviceId, taskId: task.id})"
                   (onEditEquippedBound)="onEditBoundEquipment.emit({task: $event.task, event: $event.event})"
                   (onTaskSelectToggle)="onTaskSelectToggle.emit($event)">

    </app-task-item>

  </cdk-virtual-scroll-viewport>

  <!--Task List Empty State-->
  <div *ngIf="tasks && !tasks.length"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                     text="No Assigned Tasks">

    </app-empty-state>
  </div>

  <!--Loading Mode-->
  <div *ngIf="!tasks"
       class="flex layout-row layout-align-center-center">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

</div>
